import { calculateEditorPosition, getCellBounds, ICellBounds } from './editor-position-helper'

export const getEditorStyle = (editorHeight: number, isAutoHeight?: boolean): React.CSSProperties => {
  const bounds: ICellBounds = getCellBounds()
  const windowHeight = window.innerHeight

  let styleOverride = {}

  if (bounds) {
    const { top, left } = calculateEditorPosition(bounds, editorHeight, windowHeight)

    styleOverride = {
      position: 'absolute',
      top: `${top}px`,
      left: `${left}px`,
      height: isAutoHeight ? 'auto' : `${editorHeight}px`,
      maxHeight: isAutoHeight ? 'auto' : `${editorHeight}px !important`,
      zIndex: 99999,
    }
  }

  return styleOverride
}
